import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOrderExcelResponse } from '~/types/order.types';

/**
 * [입고관리 > 입고요청관리] 입고 상품 엑셀 업로드 API
 */
const usePostOrderExcel = () => {
  const endPoint = '/api-oms/order/excel';

  const postOrderExcel = async (file: File) => {
    return axiosInstance
      .post<TypePostOrderExcelResponse>(
        endPoint,
        { file },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then(({ data }) => {
        return data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOrderExcel };
};

export default usePostOrderExcel;
